/**
 * Event type helpers — moved from ChatbotSettingsPage so multiple components
 * (sidebar card, detail header, config form, overview summary) can share them.
 */
import {
  Tag,
  Tags,
  UserPlus,
  UserMinus,
  Bot,
  Sparkles,
} from "lucide-react";

export const ZALO_TAG_EVENT_TYPES = ["add_tag_zalo", "remove_tag_zalo"];
export const AKABIZ_TAG_EVENT_TYPES = ["add_tag_akabiz", "remove_tag_akabiz"];
export const TAG_EVENT_TYPES = [
  ...ZALO_TAG_EVENT_TYPES,
  ...AKABIZ_TAG_EVENT_TYPES,
];
export const GROUP_EVENT_TYPES = ["join_group", "leave_group"];

export const isTagEvent = (t) => TAG_EVENT_TYPES.includes(t);
export const isZaloTagEvent = (t) => ZALO_TAG_EVENT_TYPES.includes(t);
export const isAkabizTagEvent = (t) => AKABIZ_TAG_EVENT_TYPES.includes(t);
export const isGroupEvent = (t) => GROUP_EVENT_TYPES.includes(t);
export const isConditionEvent = (t) => isTagEvent(t) || isGroupEvent(t);

/** Solid color (hex) for chips and dots — matches the existing palette. */
export const eventTypeChipColor = (eventType) => {
  if (!eventType) return "#6b7280";
  if (eventType.startsWith("add_tag_")) return "#16a34a";
  if (eventType.startsWith("remove_tag_")) return "#dc2626";
  if (eventType === "join_group") return "#0ea5e9";
  if (eventType === "leave_group") return "#f59e0b";
  return "#6366f1";
};

/** Tailwind color tokens for the gradient avatar in BotListSidebar / Detail. */
export const eventTypeGradient = (eventType) => {
  if (!eventType) return "from-gray-400 to-gray-500";
  if (eventType.startsWith("add_tag_")) return "from-emerald-500 to-green-600";
  if (eventType.startsWith("remove_tag_")) return "from-rose-500 to-red-600";
  if (eventType === "join_group") return "from-sky-500 to-blue-600";
  if (eventType === "leave_group") return "from-amber-500 to-orange-600";
  return "from-indigo-500 to-purple-600";
};

/** Lucide icon component for the event type. */
export const eventTypeIcon = (eventType) => {
  if (!eventType) return Bot;
  if (eventType.startsWith("add_tag_")) return Tag;
  if (eventType.startsWith("remove_tag_")) return Tags;
  if (eventType === "join_group") return UserPlus;
  if (eventType === "leave_group") return UserMinus;
  return Sparkles;
};
